import React, { Suspense, useEffect } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import '@fortawesome/fontawesome-free/css/all.min.css'
import '../src/styles/custom.css'
import '../src/styles/print.css'
import Home from './layouts/Home'
import { useDispatch, useSelector } from 'react-redux'
import { general } from './store/actions/generalActions'
import AttorneyLayout from './layouts/AttorneyLayout'
import ClientLayout from './layouts/ClientLayout'
import ScrollToTop from './components/ScrollToTop'
import AdminLayout from './layouts/AdminLayout'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

function App() {
  const language = useSelector((state) => state.language)
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(general(language))
  }, [language])

  return (
    <BrowserRouter>
      <Suspense fallback={true}>
        <ScrollToTop />
        <Routes>
          <Route exact path="*" name="homepage" element={<Home />} />
          <Route exact path="/attorney/*" name="attorney" element={<AttorneyLayout />} />
          <Route exact path="/client/*" name="client" element={<ClientLayout />} />
          <Route exact path="/admin/*" name="admin" element={<AdminLayout />} />
        </Routes>
      </Suspense>
      <ToastContainer position="top-center" autoClose={5000} />
    </BrowserRouter>
  )
}

export default App
